<template>
  <div class="my-register-page mb-5 pr-view">
    <div class="my-container">
      <b-row class="mb-3 mt-3 pt-3">
        <b-col>
          <a class="pr-back" @click.prevent="$router.go(-1)" href="#">
            <b-icon icon="arrow-left"></b-icon>
            {{ $t("PublicReceptionBack") }}
          </a>
        </b-col>
      </b-row>

      <div class="pr-card-wrapper">
        <div class="pr-card-badges mb-3">
          <span v-if="DisplayReceptionType" class="pr-badge pr-badge-type">
            {{ DisplayReceptionType }}
          </span>
          <span v-if="Item.status" class="pr-badge pr-badge-status">
            {{ Item.status }}
          </span>
          <span v-if="Item.docNumber" class="pr-badge pr-badge-doc">
            {{ Item.docNumber }}
          </span>
        </div>

        <h1 class="pr-title">{{ Item.name }}</h1>

        <div class="pr-info-grid mt-4">
          <div class="pr-info-item" v-if="Item.receptionDate">
            <div class="pr-info-icon">
              <b-icon icon="calendar2-event"></b-icon>
            </div>
            <div>
              <div class="pr-info-label">{{ $t("PRDate") }}</div>
              <div class="pr-info-value">{{ Item.receptionDate }}</div>
            </div>
          </div>
          <div class="pr-info-item" v-if="Item.docDate">
            <div class="pr-info-icon">
              <b-icon icon="file-earmark-text"></b-icon>
            </div>
            <div>
              <div class="pr-info-label">{{ $t("docDate") }}</div>
              <div class="pr-info-value">{{ Item.docDate }}</div>
            </div>
          </div>
          <div class="pr-info-item" v-if="Item.region">
            <div class="pr-info-icon">
              <b-icon icon="geo-alt"></b-icon>
            </div>
            <div>
              <div class="pr-info-label">{{ $t("PRAddress") }}</div>
              <div class="pr-info-value">
                {{ Item.region }}<span v-if="Item.district">, {{ Item.district }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="pr-stats-row mt-4 d-flex flex-wrap"
          v-if="Item.totalEmployeesCount != null || Item.applicationsCount != null">
          <div class="pr-stat-card" v-if="Item.totalEmployeesCount != null">
            <div class="pr-stat-label">{{ $t("PRRegisteredEmployees") }}</div>
            <div class="pr-stat-value">
              {{ Item.registeredEmployeesCount || 0 }} / {{ Item.totalEmployeesCount || 0 }}
            </div>
          </div>
          <div class="pr-stat-card" v-if="Item.applicationsCount != null">
            <div class="pr-stat-label">{{ $t("PRApplications") }}</div>
            <div class="pr-stat-value">{{ Item.applicationsCount }}</div>
          </div>
        </div>

        <div class="pr-section mt-4" v-if="Participants.length > 0">
          <div class="pr-section-label">
            {{ $t("PRParticipants") }}
          </div>
          <b-table-simple bordered class="mt-2 pr-table" responsive>
            <b-thead>
              <b-tr>
                <b-th >{{ $t("organization") }}</b-th>
                <b-th style="width:400px">{{ $t("PROfficial") }}</b-th>
                <b-th style="width:200px">{{ $t("position") }}</b-th>
                <b-th style="width:200px">{{ $t("PRContact") }}</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(p, idx) in Participants" :key="idx">
                <b-td>
                  <b-icon icon="building"></b-icon>
                  {{ p.organization || p.organizationName }}
                </b-td>
                <b-td style="width:300px">
                  {{ p.fullName || p.employeeFullName }}
                </b-td>
                <b-td style="width:200px">{{ p.position }}</b-td>
                <b-td class="pr-link" style="width:200px">
                  {{ p.phoneNumber }}
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>

        <div class="pr-section mt-4" v-if="Item.fullAddress || Item.address">
          <div class="pr-section-label">{{ $t("PRFullAddress") }}</div>
          <div class="pr-address mt-2">
            <div class="pr-address-value">
              <b-icon icon="geo-alt"></b-icon>
              {{ Item.fullAddress || Item.address }}
            </div>
          </div>

          <div class="pr-map mt-3" v-if="hasCoordinates">
            <yandex-map :coords="MapCoords" :zoom="16" :controls="['zoomControl']"
              style="width: 100%; height: 380px; border-radius: 12px">
              <ymap-marker :coords="MapCoords" marker-id="pr-marker" :marker-type="'placemark'" />
            </yandex-map>
          </div>

          <div class="pr-map-buttons mt-3 d-flex flex-wrap" v-if="hasCoordinates">
            <b-button variant="outline-secondary"
              :href="`https://www.google.com/maps?q=${Item.latitude},${Item.longitude}`" target="_blank"
              class="pr-map-btn">
              <b-icon icon="cursor"></b-icon>
              {{ $t("PROpenGoogleMaps") }}
            </b-button>
            <b-button variant="outline-secondary"
              :href="`https://yandex.com/maps/?pt=${Item.longitude},${Item.latitude}&z=16&l=map`" target="_blank"
              class="pr-map-btn">
              <b-icon icon="cursor"></b-icon>
              {{ $t("PROpenYandexMaps") }}
            </b-button>
          </div>
        </div>

        <div class="pr-section mt-4" v-if="Item.description">
          <div class="pr-section-label">{{ $t("PRDescription") }}</div>
          <p class="pr-description mt-2">{{ Item.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PublicReceptionService from "@/services/publicreception.service";
import {
  BRow,
  BCol,
  BButton,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BIcon,
} from "bootstrap-vue";
import { yandexMap, ymapMarker } from "vue-yandex-maps";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BIcon,
    yandexMap,
    ymapMarker,
  },
  data() {
    return {
      Item: {},
    };
  },
  computed: {
    hasCoordinates() {
      return !!(this.Item.latitude && this.Item.longitude);
    },
    MapCoords() {
      return [
        Number(this.Item.latitude) || 41.311081,
        Number(this.Item.longitude) || 69.240562,
      ];
    },
    Participants() {
      const orgs = Array.isArray(this.Item.organizations)
        ? this.Item.organizations
        : null;

      if (orgs) {
        const flat = [];
        orgs.forEach((org) => {
          const name = org.organization || org.organizationName || "";
          const employees = Array.isArray(org.employees) ? org.employees : [];
          if (employees.length === 0) {
            flat.push({
              organization: name,
              fullName: "",
              position: "",
              phoneNumber: "",
            });
          } else {
            employees.forEach((emp) => {
              flat.push({
                organization: name,
                fullName: emp.fullName || emp.employeeFullName || "",
                position: emp.position || "",
                phoneNumber: emp.phoneNumber || "",
              });
            });
          }
        });
        return flat;
      }

      return (
        this.Item.participants ||
        this.Item.employees ||
        this.Item.registeredEmployees ||
        []
      );
    },
    DisplayReceptionType() {
      const v = this.Item.receptionType;
      if (!v) return "";
      if (/^[A-Z][A-Za-z0-9]*(\.[A-Z][A-Za-z0-9]+){2,}/.test(v)) return "";
      return v;
    },
  },
  created() {
    this.Refresh();
  },
  methods: {
    Refresh() {
      PublicReceptionService.Get(this.$route.params.id)
        .then((res) => {
          this.Item = res.data || {};
        })
        .catch((error) => {
          this.makeToast(
            error.response ? error.response.data : error.message,
            "error"
          );
        });
    },
    makeToast(message, type) {
      var a = "";
      if (message && message.status == 500) {
        a = message.title;
      } else if (message && message.status == 400) {
        var errors = Object.values(message.errors);
        a = errors.map((el, i) => i + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.pr-back {
  color: $primary-dark;
  font-weight: 500;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:hover {
    color: $primary;
  }
}

.pr-card-wrapper {
  background: #fff;
  border: 1px solid #e2e6ee;
  border-radius: 16px;
  padding: 28px;
}

.pr-card-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.pr-badge {
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
}

.pr-badge-type {
  background: #fff4e6;
  color: #b8651b;
}

.pr-badge-status {
  background: #eef4ff;
  color: $primary-dark;
}

.pr-badge-doc {
  background: #f1f3f5;
  color: #495057;
}

.pr-stats-row {
  gap: 12px;
}

.pr-stat-card {
  background: #f7f9fc;
  border-radius: 12px;
  padding: 12px 16px;
  min-width: 180px;
}

.pr-stat-label {
  text-transform: uppercase;
  font-size: 11px;
  color: #6c7888;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.pr-stat-value {
  font-size: 18px;
  font-weight: 700;
  color: $primary-dark;
}

.pr-title {
  font-size: 28px;
  font-weight: 700;
  color: $primary-dark;
  margin: 0;
}

.pr-section-label {
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c7888;
  font-size: 12px;
  font-weight: 600;
}

.pr-table {
  font-size: 14px;

  th {
    background: #f7f9fc;
    color: #6c7888;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  td {
    vertical-align: middle;
    color: $primary-dark;
  }
}

.pr-link {
  color: $primary;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.pr-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  border-top: 1px solid #eef0f4;
  border-bottom: 1px solid #eef0f4;
  padding: 16px 0;
}

.pr-info-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.pr-info-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #eef4ff;
  color: $primary;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pr-info-label {
  text-transform: uppercase;
  font-size: 11px;
  color: #6c7888;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.pr-info-value {
  font-size: 15px;
  color: $primary-dark;
  font-weight: 600;
}

.pr-address {
  background: #f7f9fc;
  border-radius: 12px;
  padding: 14px 18px;
}

.pr-address-label {
  text-transform: uppercase;
  font-size: 11px;
  color: #6c7888;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.pr-address-value {
  margin-top: 4px;
  color: $primary-dark;
  font-weight: 500;
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.pr-map-buttons {
  gap: 8px;
}

.pr-map-btn {
  border-radius: 8px;
}

.pr-description {
  color: $primary-dark;
  margin: 0;
}
</style>
